<xm-ee-basic-widget
  [options]="options"
  [controlValue]="controlValue"
  [validators]="validators"
  type="number"
  (valueChanged)="changeText($event)"
></xm-ee-basic-widget>
